'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flatten;

var _flattenN2 = require('./internal/_flattenN');

var _flattenN3 = _interopRequireDefault(_flattenN2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Flattens an iterable as deeply as possible.
 *
 * @example
 * // return List [ 1, 2, 3, 4, 5, 6 ]
 * flatten(List.of(List.of(1, List.of(2, 3)), List.of(4, 5, 6)));
 *
 * @param {Iterable} subject
 * @return {Iterable}
 */
function flatten(subject) {
  return (0, _flattenN3.default)(Infinity, subject);
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/transmute/static-2.3/flatten.js
// module id = 351
// module chunks = 0 1